import React from "react";

import { useGetFormattedEmployeeDataQuery, useGetCurrentCompanyApplicationQuery, useGetCompanyContributionsQuery } from "EmployerApplication/api";
import StaticEmployeeDetailsBody from "EmployerApplication/Components/CostBreakdown/StaticEmployeeDetailsBody";
import AnalyticsTracking from "Utils/AnalyticsTracking";

import { TitleSmall } from "Cobalt/Header";
import { StandaloneTrigger, Modal, ModalBody, ModalHeader, ModalFooter } from "Cobalt/Modal";
import Button from "Common/Button";
import { CONTRIBUTION_TYPES } from "Common/Constants";

const StaticCostBreakdownModal = ({ medicalPlans, dentalPlan, visionPlan, useGrayButtonTrigger }) => {
  const { refetch: refetchFormattedEmployeeData } = useGetFormattedEmployeeDataQuery();
  const { data: companyApplication } = useGetCurrentCompanyApplicationQuery();
  const companyPolicyId = companyApplication?.id;
  const { data: companyContributions } = useGetCompanyContributionsQuery(companyPolicyId, { skip: !companyPolicyId });
  const { data: employeeProfileData } = useGetFormattedEmployeeDataQuery();

  const contributionType = CONTRIBUTION_TYPES[companyApplication?.typeOfContribution] || CONTRIBUTION_TYPES.percentage;
  const contributions = companyContributions?.filter((contribution) => contribution.active);
  const employeeProfile = employeeProfileData?.formatted_employee_data || [];

  return (
    <StandaloneTrigger
      trigger={(props) =>
        React.createElement(
          useGrayButtonTrigger ? Button : "a",
          {
            color: "gray",
            href: "#",
            onClick: (e) => {
              props.onClick(e);
              refetchFormattedEmployeeData();
              AnalyticsTracking.trackEvent("employee_costs_viewed", {
                location: "quote_information_panel",
                medicalPlans,
                contributionType,
                contributions,
              });
            },
            style: { width: "100%" },
            ...props,
          },

          "View Cost Breakdown",
        )
      }
      modal={(props) => (
        <Modal className="modal-xl" {...props}>
          <ModalHeader closeButton>
            <TitleSmall mb={0} mt={0}>
              Final Cost Breakdown
            </TitleSmall>
          </ModalHeader>
          <ModalBody>
            <StaticEmployeeDetailsBody
              employeeProfile={employeeProfile}
              contributionType={contributionType}
              applicationContribution={contributions}
              medicalPlans={medicalPlans}
              initialVisionPlan={visionPlan}
              initialDentalPlan={dentalPlan}
            />
          </ModalBody>
          <ModalFooter>
            <Button onClick={() => props.onHide()}>Finish</Button>
          </ModalFooter>
        </Modal>
      )}
    />
  );
};

export default StaticCostBreakdownModal;
